import { z } from 'zod';

export const GuaranteedValueSchema = z.object({
  base: z.number(),
  penalty: z.number(),
  effective: z.number(),
});

export type GuaranteedValue = z.infer<typeof GuaranteedValueSchema>;
